import nunjucks from "nunjucks";

const env = new nunjucks.Environment(undefined, {
  autoescape: true,
  throwOnUndefined: false,
  trimBlocks: true,
  lstripBlocks: true,
});

env.addFilter("formatPrice", (value: number): string => {
  return value.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
});

env.addFilter(
  "currency",
  (value: number, currencyCode: string = "LKR"): string => {
    return `${currencyCode} ${value.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  },
);

env.addFilter(
  "dateFormat",
  (date: Date | string, format: string = "en-GB"): string => {
    const dateObj = typeof date === "string" ? new Date(date) : date;
    return dateObj.toLocaleDateString(format, {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  },
);

env.addFilter("dateTimeFormat", (date: Date | string): string => {
  if (!date) return "";
  const d = typeof date === "string" ? new Date(date) : date;
  if (isNaN(d.getTime())) return String(date);
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd} ${hh}:${min}`;
});

export { env };

/**
 * Render a Nunjucks template from string
 * @param templateString - Template content as string
 * @param context - Data context for the template
 * @returns Rendered HTML string
 */
export function renderTemplate(templateString: string, context: any): string {
  try {
    return env.renderString(templateString, context);
  } catch (error) {
    console.error("Error rendering template:", error);
    throw error;
  }
}

/**
 * Render template from string
 * @param templateString - Template string
 * @param context - Data context
 * @returns Rendered HTML string
 */
export function renderString(templateString: string, context: any): string {
  try {
    return env.renderString(templateString, context);
  } catch (error) {
    console.error("Error rendering template string:", error);
    throw error;
  }
}
